import { useEffect } from 'react';
import Header from '@/components/feature/Header';
import Frame from '@/components/base/Frame';
import IntroSection from './components/IntroSection';
import FrictionSection from './components/FrictionSection';
import RoutingSection from './components/RoutingSection';
import ImplementSection from './components/ImplementSection';
import ConsultSection from './components/ConsultSection';

export default function CustomerOperationsPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Customer Operations Automation — AI Triage & Routing | methodic';
  }, []);

  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />
      <main>
        <Frame>
          <IntroSection />
          <FrictionSection />
          <RoutingSection />
          <ImplementSection />
          <ConsultSection />
        </Frame>
      </main>
    </div>
  );
}